import ActionTypes from '../constants/ActionTypes';

const fetchMonthlyReport = (pointSystemId, year, month) => ({
  type: ActionTypes.MONTHLY_REPORT_FETCH,
  payload: {
    pointSystemId,
    year,
    month,
  },
});

fetchMonthlyReport.success = (item) => ({
  type: ActionTypes.MONTHLY_REPORT_FETCH__SUCCESS,
  payload: {
    item,
  },
});

fetchMonthlyReport.failure = (error) => ({
  type: ActionTypes.MONTHLY_REPORT_FETCH__FAILURE,
  payload: {
    error,
  },
});

export default {
  fetchMonthlyReport,
};

